import React from 'react'
import { Tag } from 'antd'
import { Text } from 'styles/reactnative'
import EntryTime from '../../PositionColumns/EntryTime'
import { TagWrap } from './styles'

// 로그 코드별 한글 설명
const LOG_DESCRIPTIONS: { [key: string]: string } = {
	// 회원 관리
	USER_CREATE: '회원 생성',
	USER_UPDATE: '회원 정보 수정',
	USER_DELETE: '회원 삭제',
	USER_PASSWORD: '비밀번호 변경',
	USER_APPROVE: '회원 승인',
	USER_SETTING: '회원 설정 변경',
	USER_SETTING_DEL: '회원 설정 삭제',
	USER_LOGOUT: '강제 로그아웃',

	// 지갑/자금 관리
	WALLET_MANUAL: '수동 입출금',
	WALLET_MEMO: '지갑 메모 변경',
	CASH_DEPOSIT: '입금 승인',
	CASH_MODIFY: '현금 수정',
	CASH_MEMO: '현금 메모',
	DW_MODIFY: '입출금 내역 수정',

	// 거래 관리
	TRADE_ORDER: '주문 생성',
	TRADE_CANCEL: '주문 취소',
	TRADE_CANCEL_ALL: '전체 주문 취소',

	// 슬리피지 관리
	SLIP_USER: '개인 슬리피지 설정',
	SLIP_GROUP: '그룹 슬리피지 설정',
	SLIP_SYSTEM: '시스템 슬리피지 설정',

	// 페어 관리
	PAIR_ADD: '페어 추가',
	PAIR_MODIFY: '페어 수정',
	PAIR_GROUP: '그룹 페어 설정',
	PAIR_PERSON: '개인 페어 설정',
	PAIR_DELETE: '페어 삭제',
	PAIR_PERSON_DEL: '개인 페어 삭제',

	// 권한 관리
	PERMISSION_SET: '권한 부여',
	PERMISSION_DEL: '권한 삭제',

	// 시스템 설정
	SETTING_SYSTEM: '시스템 설정',
	SETTING_USER: '사용자 설정',
	SETTING_EXCHANGE: '거래소 설정',
	EXCHANGE_STATUS: '거래소 상태 변경',

	// 추천인 관리
	REFERRAL_CREATE: '추천인 생성',
	REFERRAL_UPDATE: '추천인 수정',
	REFERRAL_DELETE: '추천인 삭제',

	// IP 관리
	IP_BLACK_ADD: '블랙리스트 추가',
	IP_BLACK_DEL: '블랙리스트 삭제',
	IP_DELETE: 'IP 삭제',

	// 가상계좌 관리
	VACCOUNT_SET: '가상계좌 설정',
	VACCOUNT_STATUS: '가상계좌 상태 변경',

	// 기타
	CURRENCY_UPDATE: '환율 수정',
	CURRENCY_REFRESH: '환율 새로고침',
	BALANCE_RESET: '잔고 리셋',
	LOCK_COUNT_MODIFY: '락카운트 수정',
}

// 로그 코드별 색상
const LOG_COLORS: { [key: string]: string } = {
	USER_CREATE: 'green',
	USER_UPDATE: 'blue',
	USER_DELETE: 'red',
	USER_PASSWORD: 'orange',
	USER_APPROVE: 'cyan',
	USER_SETTING: 'geekblue',
	USER_SETTING_DEL: 'volcano',
	USER_LOGOUT: 'magenta',

	WALLET_MANUAL: 'purple',
	WALLET_MEMO: 'blue',
	CASH_DEPOSIT: 'cyan',
	CASH_MODIFY: 'geekblue',
	CASH_MEMO: 'blue',
	DW_MODIFY: 'purple',

	TRADE_ORDER: 'geekblue',
	TRADE_CANCEL: 'volcano',
	TRADE_CANCEL_ALL: 'red',

	SLIP_USER: 'orange',
	SLIP_GROUP: 'gold',
	SLIP_SYSTEM: 'lime',

	PAIR_ADD: 'green',
	PAIR_MODIFY: 'blue',
	PAIR_GROUP: 'cyan',
	PAIR_PERSON: 'geekblue',
	PAIR_DELETE: 'red',
	PAIR_PERSON_DEL: 'volcano',

	PERMISSION_SET: 'green',
	PERMISSION_DEL: 'red',

	SETTING_SYSTEM: 'purple',
	SETTING_USER: 'blue',
	SETTING_EXCHANGE: 'cyan',
	EXCHANGE_STATUS: 'orange',

	REFERRAL_CREATE: 'green',
	REFERRAL_UPDATE: 'blue',
	REFERRAL_DELETE: 'red',

	IP_BLACK_ADD: 'red',
	IP_BLACK_DEL: 'green',
	IP_DELETE: 'volcano',

	VACCOUNT_SET: 'cyan',
	VACCOUNT_STATUS: 'blue',

	CURRENCY_UPDATE: 'gold',
	CURRENCY_REFRESH: 'lime',
	BALANCE_RESET: 'volcano',
	LOCK_COUNT_MODIFY: 'orange',
}

export const column_admin_log = (mutate: any) => {
	return [
		{
			title: '일시',
			dataIndex: 'created_at',
			key: 'created_at',
			align: 'center' as const,
			width: 150,
			render: (text: string) => {
				return <EntryTime time={text} style={{ fontSize: 12 }} />
			},
		},
		{
			title: '작업',
			dataIndex: 'log',
			key: 'log',
			align: 'center' as const,
			width: 150,
			render: (log: string) => {
				return (
					<Tag color={LOG_COLORS[log] || 'default'}>
						{LOG_DESCRIPTIONS[log] || log}
					</Tag>
				)
			},
		},
		{
			title: '관리자',
			key: 'admin',
			align: 'center' as const,
			width: 200,
			render: (record: any) => {
				return (
					<div>
						<div style={{ fontWeight: 500 }}>
							{record.admin_nickname || '-'}
						</div>
						<div style={{ fontSize: '11px', color: '#888' }}>
							{record.admin_loginid || '-'} (Lv.{record.admin_level || '-'})
						</div>
					</div>
				)
			},
		},
		{
			title: '상세 내용',
			dataIndex: 'data',
			key: 'data',
			align: 'left' as const,
			render: (text: string, record: any) => {
				try {
					const data = JSON.parse(text)
					const entries = Object.entries(data)

					if (entries.length === 0) {
						return <Text style={{ fontSize: '12px', color: '#999' }}>-</Text>
					}

					// 모든 필드를 한 줄로 간단하게 표시
					const summary = entries
						.map(([key, value]: [string, any]) => {
							const displayValue = typeof value === 'object'
								? JSON.stringify(value)
								: String(value)
							return `${key}: ${displayValue}`
						})
						.join(' / ')

					return (
						<Text style={{ fontSize: '12px', color: '#333' }}>
							{summary}
						</Text>
					)
				} catch (e) {
					return <Text style={{ fontSize: '12px', color: '#999' }}>{text || '-'}</Text>
				}
			},
		},
	]
}
